<template>
  <div
    :id="containerId"
    class="app-background"
  />
</template>

<script>
export default {
  name: 'AppBackground',
  data: () => ({
    breakpoints: useBreakpoints(),
    containerId: 'app_background',
  }),
  computed: {
    starsAmount() {
      return this.breakpoints.smAndDown ? 100 : 200
    },
  },
  mounted() {
    this.addStars()
  },
  methods: {
    createStar() {
      const star = document.createElement('div');
      star.classList.add('star');
      star.classList.add('shining');
      star.style.top = Math.random() * 100 + '%';
      star.style.left = Math.random() * 100 + '%';
      star.style.width = Math.random() * 3 + 'px';
      star.style.height = star.style.width;
      star.style.animationDelay = Math.random() * 2 + 's';
      return star;
    },
    addStars() {
      const container = document.getElementById(this.containerId);
      if (!container) {
        return;
      };

      for (let i = 0; i <= this.starsAmount; i++) {
        const star = this.createStar();
        container.appendChild(star);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-background {
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
}
</style>
